export const environment = {
  production: true,
  DEV_BYPASS_INVITE: false,
  URL: 'https://atcpartnersportal-uat-g0f0hqd5bvhkhcbs.southeastasia-01.azurewebsites.net',
  API_URL: 'https://uat.atcprtnersportal.atram.app/api/pp-uat'
};
